import _ from 'lodash';
import { CancelToken } from 'axios';
import { OmnitechApi } from '../../api';
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchColorMasters(options = {}) {
  const { page = 1 } = options
  const params = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchColorMasters',
    () => source.cancel('fetchColorMasters: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'color_masters',
      method: 'get',
      params,
      CancelToken: source.token,
      arrayFormat: 'brackets'
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      colorMasters: _.get(data, 'colorMasters', {}),
      next: _.get(data, 'colorMastersPagination.nextPage') > page
        ? () => fetchColorMasters({
          page: page + 1,
          ...others
        })
        : null,
      count: _.get(data, 'colorMastersPagination.totalCount')
    }))
};
